<script setup>
import {computed, onMounted, ref} from "vue";
import { useStore } from "vuex";
import axios from "axios";
import {useRoute} from "vue-router";
import customerCase from "@/assets/images/bg/customer-case-bg.png";
import PageHead from "@/components/PageHead/PageHead.vue";
import Width from "@/pages/Index/Width.vue";

const store = useStore()
const route = useRoute()

const customerCaseDetail = ref(null)

const currentLang = computed(() => store.getters.currentLanguage)
const getCustomerCase = async () => {
	const res = await axios.get(`/api/api/strength/${route.params.id}`)
		.catch(err => {
			throw new Error(err.message)
		})
	
	const processedData = Object.entries(res.data).reduce((acc, [key, value]) => {
		if (key.startsWith('content_')) {
			acc[key] = processRichTextImages(value);
		} else {
			acc[key] = value;
		}
		return acc;
	}, {});
	
	console.log('res --------->', res)
	customerCaseDetail.value = processedData
}

function processRichTextImages(html) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');
	const images = doc.querySelectorAll('img');
	
	images.forEach(img => {
		img.style.maxWidth = '100%';
		img.style.height = 'auto';
	});
	
	return doc.body.innerHTML;
}

onMounted(() => {
	getCustomerCase()
})
</script>

<template>
	<div class="customer-case-details">
		<PageHead
			:bg-image="customerCase"
			:title="$t('header.CustomerCase')"
		/>
		
		<Width>
			<div class="customer-case-details__content">
				<div class="title">
					{{ customerCaseDetail?.[`title_${currentLang}`] }}
				</div>
				
				<div class="content" v-html="customerCaseDetail?.[`content_${currentLang}`]" />
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
img {
	max-width: 100% !important;
	height: auto !important;
}
.customer-case-details {
	background-color: #F5F5F5;
	&__content {
		padding: 70px 0;
		min-height: 300px;
		color: #3D3D3D;
		
		.title {
			text-align: center;
			font-size: 32px;
			font-weight: bold;
			line-height: 22px;
			word-wrap: break-word;
			word-break: break-word;
		}
		
		.content {
			margin-top: 30px;
			font-size: 18px;
			line-height: 32px;
			p {
				font-size: 18px;
				line-height: 36px;
				color: #3D3D3D;
			}
		}
		
	}
	
}

@media screen  and (max-width: 1024px ) {
	.customer-case-details {
		
		&__content {
			padding: 30px 0;
			
			.title {
				font-size: 24px;
			}
			
			.content {
				margin-top: 20px;
				font-size: 16px;
				line-height: 24px;
				//p {
				//	font-size: 16px;
				//	line-height: 24px;
				//	color: #3D3D3D;
				//}
			}
			
		}
		
	}
}
</style>